import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";


export class VoucherOnChangeAction extends BaseAction<void, string> {
    override async run(): Promise<void> {
        try {
            const regex = /^[a-zA-Z0-9]*$/;
            if (regex.test(this.params || "")) {
                let voucherCode = this.params || ""
                updateRecoilState("voucherCodeAtom", voucherCode);
                updateRecoilState("voucherErrorAtom", "");
            }
        } catch (error) {
            console.error("Error during my account action menu click:", error);
        }
    }
}

export const voucherOnChangeAction = new VoucherOnChangeAction();
